import { createSlice, Reducer } from '@reduxjs/toolkit';
import {
  addScorecardsCases,
  addCareerMentorOptionsCases,
} from 'store/scorecards/index';
import { cloneDeep } from 'lodash-es';
import { resetState } from 'store/actions';
import { storeName, teamProfilesInitialState, initialFilters } from './config';

export * from './interfaces';

const teamProfiles = createSlice({
  name: storeName,
  initialState: cloneDeep(teamProfilesInitialState),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetState, (state) => {
      const newState = cloneDeep(teamProfilesInitialState);
      newState.filters = state.filters;
      Object.assign(state, newState);
    });
    addCareerMentorOptionsCases(builder, storeName);
    addScorecardsCases(builder, storeName, cloneDeep(initialFilters));
  },
});

export default teamProfiles.reducer as Reducer<typeof teamProfilesInitialState>;
